import React from 'react'
import Slider from './Slider';
import MarqueeLComList from './MarqueeLComList';

const HomeComponent = () => {
    return (
        <>
            <div className='row m-0'>
                <div className='col-md-8'>
                    <div className='row'>
                        <div className='col-lg-11 offset-lg-1     '>
                            <div className='img text-end'>

                                <Slider />
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-4  d-flex justify-content-start'
                    style={{
                    }}>
                    <div
                        className='api'
                        style={{
                            boxShadow: "0px 0px 15px -10px #000000",
                            marginTop: 23.8,
                            minWidth: "85%"

                        }}
                    >
                        <MarqueeLComList />
                    </div>
                </div>
            </div>

            <br />
            <br />
            {/* <br /> */}
        </>
    )
}

export default HomeComponent;